module.exports = __webpack_public_path__ + "img/carMgt.c6d94a4b.svg";